<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_goods_spec_no') || '产品规格编号'"
            prop="orderGoodsSpecNo"
          >
            <el-input clearable v-model="formData.orderGoodsSpecNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                :disabled="techGoodsSpecCode.length > 0"
                @click="() => (orderGoodsDialogVisible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_identify_No') || '标识号'"
            prop="identifyNo"
          >
            <el-input clearable v-model="formData.identifyNo"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button
          @click="() => this.$emit('save')"
          type="primary"
          size="small"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>

    <ChooseOrderGoodsSpecDialog
      :visible.sync="orderGoodsDialogVisible"
      :title="$l('dialog_label_add_order_goods_spec') || '添加订单产品规格'"
      :orderCode="orderCode"
      @confirm="onOrderGoodsConfirm"
      append-to-body
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderGoodsSpecDialog from '@/views/factory/components/choose-order-goods-spec/dialog.vue'
export default {
  components: {
    ChooseOrderGoodsSpecDialog,
  },
  mixins: [EditLoading],
  props: {
    techGoodsSpecCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      orderGoodsDialogVisible: false,
      formData: { orderGoodsSpecNo: '' },
      rules: {
        orderGoodsSpecNo: [
          {
            required: true,
            message:
              this.$l('form_label_pe_add_order_goods_spec') ||
              '请添加订单产品规格',
            trigger: 'blur',
          },
        ],
        identifyNo: [
          {
            required: true,
            message: this.$l('form_label_pe_add_identify_No') || '请添加标识号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsSpecCode) return
      this.$api
        .techGoodsSpecDetailApi({
          techGoodsSpecCode: this.techGoodsSpecCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async getFormData() {
      const result = await validate.formValidate([this.$refs.formData])
      this.backDialogVisible = false
      if (result) return this.formData
      return false
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onOrderGoodsConfirm(data) {
      this.formData.orderGoodsSpecCode = data.orderGoodsSpecCode
      this.formData.orderGoodsSpecNo = data.orderGoodsSpecNo
      this.formData.orderGoodsCode = data.orderGoodsCode
    },
  },
}
</script>
